import { get_token } from "@/router";
import Swal from "sweetalert2";


function get_empty_section_18a_form() {
  return ({
    registration_number: "",
    income_tax_reference_number: "",
    pbo_number: "",
    effective_date: "",
    approval_letter: null,
  });
}

function get_empty_section_18a_form_errors() {
  return ({
    registration_number: "",
    income_tax_reference_number: "",
    pbo_number: "",
    effective_date: "",
    approval_letter: "",
  });
}

function normalize_section_18a_value(value) {
  return String(value || "").trim();
}

export function get_organisation_section_18a_data() {
  return ({
    section_18a_config: null,
    section_18a_form: get_empty_section_18a_form(),
    section_18a_form_errors: get_empty_section_18a_form_errors(),
    section_18a_loading: false,
    section_18a_saving: false,
    section_18a_error: "",
    section_18a_is_dragging: false,
  });
}

export const organisationSection18AMethods = {
  reset_section_18a_state() {
    this.section_18a_config = null;
    this.section_18a_form = get_empty_section_18a_form();
    this.section_18a_form_errors = get_empty_section_18a_form_errors();
    this.section_18a_error = "";
    this.section_18a_loading = false;
    this.section_18a_saving = false;
    this.section_18a_is_dragging = false;
  },
  apply_section_18a_response(response) {
    this.section_18a_config = response?.data || null;
    this.section_18a_form = {
      registration_number: this.section_18a_config?.registration_number || "",
      income_tax_reference_number: this.section_18a_config?.income_tax_reference_number || "",
      pbo_number: this.section_18a_config?.pbo_number || "",
      effective_date: this.section_18a_config?.effective_date || "",
      approval_letter: null,
    };
    this.section_18a_form_errors = get_empty_section_18a_form_errors();
  },
  get_section_18a_form_data() {
    const form_data = new FormData();

    form_data.append("company_id", this.organization_company_id || "");
    form_data.append("registration_number", normalize_section_18a_value(this.section_18a_form.registration_number));
    form_data.append("income_tax_reference_number", normalize_section_18a_value(this.section_18a_form.income_tax_reference_number));
    form_data.append("pbo_number", normalize_section_18a_value(this.section_18a_form.pbo_number));
    form_data.append("effective_date", normalize_section_18a_value(this.section_18a_form.effective_date));

    if (this.section_18a_form.approval_letter instanceof File) {
      form_data.append("approval_letter", this.section_18a_form.approval_letter);
    }

    return form_data;
  },
  fetch_section_18a_config() {

    this.section_18a_loading = true;
    this.section_18a_error = "";

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/organisation/get_section_18a_config/`,
      type: "GET",
      headers: {
        Authorization: `Token ${get_token()}`,
      },
      success: (response) => {
        if (!response?.data) {
          this.section_18a_config = null;
          this.section_18a_form = get_empty_section_18a_form();
          return;
        }

        this.apply_section_18a_response(response);
      },
      error: (xhr) => {
        this.section_18a_error = xhr?.responseJSON?.message || "Could not load Section 18A details.";
      },
      complete: () => {
        this.section_18a_loading = false;
      },
    });
  },
  create_section_18a_config() {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/organisation/create_section_18a_config/`,
      type: "POST",
      headers:  {
        Authorization: `Token ${get_token()}`,
      },
      data: this.get_section_18a_form_data(),
      processData: false,
      contentType: false,
      success: (response) => {
        this.apply_section_18a_response(response);
        Swal.fire({
          icon: "success",
          title: "Section 18A details created.",
          showConfirmButton: false,
          timer: 2200,
          position: "bottom-end",
          toast: true,
        });
      },
      error: (xhr) => {
        const message = xhr?.responseJSON?.message;
        this.section_18a_error = typeof message === "string" ? message : "Could not create Section 18A details.";
      },
      complete: () => {
        this.section_18a_saving = false;
      },
    });
  },
  update_section_18a_config() {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/organisation/update_section_18a_config/`,
      type: "POST",
      headers:  {
        Authorization: `Token ${get_token()}`,
      },
      data: this.get_section_18a_form_data(),
      processData: false,
      contentType: false,
      success: (response) => {
        this.apply_section_18a_response(response);
        Swal.fire({
          icon: "success",
          title: "Section 18A details updated.",
          showConfirmButton: false,
          timer: 2200,
          position: "bottom-end",
          toast: true,
        });
      },
      error: (xhr) => {
        const message = xhr?.responseJSON?.message;
        this.section_18a_error = typeof message === "string" ? message : "Could not update Section 18A details.";
      },
      complete: () => {
        this.section_18a_saving = false;
      },
    });
  },
  save_section_18a_config() {
    this.section_18a_error = "";

    if (!this.validate_section_18a_form()) {
      return;
    }

    this.section_18a_saving = true;

    if (this.section_18a_config?.id) {
      this.update_section_18a_config();
      return;
    }

    this.create_section_18a_config();
  },
  delete_section_18a_config() {
    if (!get_token()) {
      return;
    }

    this.section_18a_error = "";

    Swal.fire({
      icon: "warning",
      title: "Delete Section 18A details?",
      text: "This will remove the saved Section 18A details and approval letter for this organisation.",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      position: "bottom-end",
      toast: true,
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.perform_section_18a_delete_request();
    });
  },
  perform_section_18a_delete_request() {
    this.section_18a_saving = true;

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/organisation/delete_section_18a_config/`,
      type: "DELETE",
      headers: {
        Authorization: `Token ${get_token()}`,
      },
      success: () => {
        this.section_18a_config = null;
        this.section_18a_form = get_empty_section_18a_form();
        Swal.fire({
          icon: "success",
          title: "Section 18A details deleted.",
          showConfirmButton: false,
          timer: 2200,
          position: "bottom-end",
          toast: true,
        });
      },
      error: (xhr) => {
        this.section_18a_error = xhr?.responseJSON?.message || "Could not delete Section 18A details.";
      },
      complete: () => {
        this.section_18a_saving = false;
      },
    });
  },
};
